import React from 'react'
import Login from "./loginbutton";
import {Helmet} from "react-helmet";

const ConsumerLogin = ({history}) => {
    return (
        <div className="flex-center flex-column p-t-10">
            <Helmet>
            <meta name="description" content="Create a free Ouja account to send parcels to your friends or relatives, customers or colleagues or to even book rides or to contribute in Ouja trust. Register Now" />
            <meta name="" content=""/>
            <meta name="keywords" content="Registration"/>
            </Helmet>
            <h3>Continue with</h3>
            <Login history={history} />
        </div>
    )
}

const LoginSection = ConsumerLogin;

export default LoginSection